export interface ThemeColors {
    'color-main': string;
    'color-main-darken': string;
    'color-main-darken2': string;
    'color-main-darken3': string;
    'color-main-lighten': string;
    'color-secondary': string;
    'color-secondary-darken': string;
    'color-secondary-darken2': string;
    'color-secondary-darken3': string;
    'color-secondary-lighten': string;
    'color-contrast-lighten': string;
    'color-contrast': string;
    'color-graph1': string;
    'color-graph2': string;
    'color-graph3': string;
    'color-graph4': string;
    'color-graph5': string;
    'color-graph6': string;
    'color-graph7': string;
    'color-graph8': string;
    'color-graph9': string;
    'color-bar-graph1': string;
    'color-bar-graph2': string;
    'color-bar-graph3': string;
    'color-bar-graph4': string;
    'color-bar-graph5': string;
    'color-bar-graph6': string;
    'color-bar-graph7': string;
    'color-bar-graph8': string;
    'color-bar-graph9': string;
    'color-transparent': string;
}

export interface ThemeColorDistribution{
    'color-header-nav': string,
    'color-header-nav-font': string,
    'color-header-nav-font-active': string,
    'color-body-theme': string,
    'color-body-font': string,
    'color-button': string,
    'color-button-font': string,
    'color-shift-button': string,
    'color-shift-button-font': string,
    'color-button-active': string,
    'color-button-active-font': string,
    'color-gauge-title-font': string,
    'color-gauge-font': string,
    'color-gauge-arc1': string,
    'color-gauge-arc2': string,
    'color-gauge-needle': string,
    'color-plot-domain1': string,
    'color-plot-domain2': string,
    'color-plot-domain3': string,
    'color-plot-domain4': string,
    'color-plot-domain5': string,
    'color-plot-domain6': string,
    'color-plot-domain7': string,
    'color-plot-domain8': string,
    'color-plot-domain9': string,
    'color-main-panel': string,
    'color-main-panel-font': string,
    'color-box-panel': string,
    'color-box-panel-font': string,
    'color-box-panel-font-highlight': string,
    'color-box-panel-label': string,
    'color-box-panel-label-font': string,
    'color-box-panel2': string,
    'color-box-panel2-font': string,
    'color-box-panel2-font-highlight': string,
    'color-footer': string,
    'color-footer-link-font-highlight': string,
    'color-footer-link-font': string,
    'color-footer-link': string,
    'color-footer-link-highlight': string,
    'color-table-header': string,
    'color-table-header-font': string,
    'color-table-row1': string,
    'color-table-row2': string,
    'color-table-row-font': string,
    'color-table-row-hover': string,
    'color-table-row-font-hover': string,
    'color-box-table-header': string,
    'color-box-table-header-font': string,
    'color-box-table-row': string,
    'color-box-table-row-font': string,
    'color-box-table-row-header': string,
    'color-box-table-row-header-font': string,
    'color-contextual-menu-item-selected': string,
    'color-contextual-menu-item-selected-font': string,
    'color-contextual-menu-item': string,
    'color-contextual-menu-item-font': string,  
    'color-line-graph-domain1': string,
    'color-line-graph-domain2': string,
    'color-line-graph-domain3': string,
    'color-line-graph-domain4': string,
    'color-line-graph-domain5': string,
    'color-line-graph-domain6': string,
    'color-line-graph-domain7': string,
    'color-line-graph-domain8': string,
    'color-line-graph-domain9': string,
}

interface ThemeColorsList {
    [name: string]: ThemeColors;
}

interface ThemeColorDistributionList {
    [name: string]: ThemeColorDistribution;
}

export const themeColorsList: ThemeColorsList = {
    DEFAULT_THEME:{
        'color-main': '#E5383A',
        'color-main-darken': '#BB181B',
        'color-main-darken2': '#A5161A',
        'color-main-darken3': '#660808',
        'color-main-lighten': '#EC7071',
        'color-secondary': '#F5F3F4',
        'color-secondary-darken': '#EAE9E9',
        'color-secondary-darken2': '#D3D3D3',
        'color-secondary-darken3': '#B1A7A6',
        'color-secondary-lighten': '#FFFFFF',
        'color-contrast-lighten': '#161A1D',
        'color-contrast': '#0B090A',
        'color-graph1': '#30475E',
        'color-graph2': '#E5383A',
        'color-graph3': '#df4b7e',
        'color-graph4': '#FACE7F',
        'color-graph5': '#FF6767',
        'color-graph6': '#4A3F35',
        'color-graph7': '#FF4301',
        'color-graph8': '#630A10',
        'color-graph9': '#a35d6a',
        'color-bar-graph1': '#1b4e6b',
        'color-bar-graph2': '#5c63a2',
        'color-bar-graph3': '#c068a8',
        'color-bar-graph4': '#ec7176',
        'color-bar-graph5': '#f4ab33',
        'color-bar-graph6': '#bd8a35',
        'color-bar-graph7': '#bd6f35',
        'color-bar-graph8': '#d6742c',
        'color-bar-graph9': '#d64c2c',
        'color-transparent': 'transparent'
    }    
};

export const themeColorDistributionList: ThemeColorDistributionList = {
    DEFAULT_THEME:{
        'color-header-nav': 'color-transparent',
        'color-header-nav-font': 'color-contrast',
        'color-header-nav-font-active': 'color-main-lighten',
        'color-body-theme': 'color-transparent',
        'color-body-font': 'color-contrast',
        'color-button': 'color-main',
        'color-button-font': 'color-secondary-lighten',
        'color-shift-button': 'color-main',
        'color-shift-button-font': 'color-secondary-lighten',
        'color-button-active': 'color-main-darken2',
        'color-button-active-font': 'color-secondary-lighten',
        'color-gauge-title-font': 'color-contrast',
        'color-gauge-font': 'color-contrast',
        'color-gauge-arc1': 'color-main',
        'color-gauge-arc2': 'color-secondary-darken3',
        'color-gauge-needle': 'color-contrast',
        'color-main-panel': 'color-secondary-lighten',
        'color-main-panel-font': 'color-contrast',
        'color-box-panel': 'color-secondary-darken',
        'color-box-panel-font': 'color-contrast',
        'color-box-panel-font-highlight': 'color-contrast',
        'color-box-panel-label': 'color-secondary-darken2',
        'color-box-panel-label-font': 'color-secondary-lighten',
        'color-box-panel2': 'color-secondary-lighten',
        'color-box-panel2-font': 'color-contrast',
        'color-box-panel2-font-highlight': 'color-contrast',
        'color-footer': 'color-secondary-darken',
        'color-footer-link-font-highlight': 'color-main',
        'color-footer-link-font': 'color-contrast-lighten',
        'color-footer-link': 'color-transparent',
        'color-footer-link-highlight': 'color-secondary-darken',
        // 'color-plot-domain2': 'color-main',
        // 'color-plot-domain3': 'color-main-darken',
        // 'color-plot-domain4': 'color-main-darken2',
        // 'color-plot-domain5': 'color-main-darken3',
        // 'color-plot-domain1': 'color-main-lighten',
        // 'color-plot-domain6': 'color-contrast',
        'color-plot-domain1': 'color-bar-graph1',
        'color-plot-domain2': 'color-bar-graph2',
        'color-plot-domain3': 'color-bar-graph3',
        'color-plot-domain4': 'color-bar-graph4',
        'color-plot-domain5': 'color-bar-graph5',
        'color-plot-domain6': 'color-bar-graph6',
        'color-plot-domain7': 'color-bar-graph7',
        'color-plot-domain8': 'color-bar-graph8',
        'color-plot-domain9': 'color-bar-graph9',
        'color-table-header': 'color-main',
        'color-table-header-font': 'color-secondary-lighten',
        'color-table-row1': 'color-secondary-darken',
        'color-table-row2': 'color-secondary',
        'color-table-row-hover': 'color-main-lighten',
        'color-table-row-font-hover': 'color-secondary-lighten',
        'color-table-row-font': 'color-contrast',
        'color-box-table-header': 'color-main-darken',
        'color-box-table-header-font': 'color-secondary-lighten',
        'color-box-table-row': 'color-secondary-darken',
        'color-box-table-row-font': 'color-contrast',
        'color-box-table-row-header': 'color-secondary-darken3',
        'color-box-table-row-header-font': 'color-secondary-lighten',
        'color-contextual-menu-item-selected': 'color-secondary-darken',
        'color-contextual-menu-item-selected-font': 'color-contrast',
        'color-contextual-menu-item': 'color-secondary-lighten',
        'color-contextual-menu-item-font': 'color-contrast',
        'color-line-graph-domain1': 'color-graph1',
        'color-line-graph-domain2': 'color-graph2',
        'color-line-graph-domain3': 'color-graph3',
        'color-line-graph-domain4': 'color-graph4',
        'color-line-graph-domain5': 'color-graph5',
        'color-line-graph-domain6': 'color-graph6',
        'color-line-graph-domain7': 'color-graph7',
        'color-line-graph-domain8': 'color-graph8',
        'color-line-graph-domain9': 'color-graph9',
    }
}

export class Theme{
    themeColors = themeColorsList.DEFAULT_THEME;
    themeColorDistribution = themeColorDistributionList.DEFAULT_THEME;

    constructor(
        themeColors: ThemeColors, 
        themeColorDistribution: ThemeColorDistribution){
        this.themeColors = themeColors;
        this.themeColorDistribution = themeColorDistribution;
    }

    getCssVarObj(){
        let cssVarObj = {};
        for(let [key, value] of Object.entries(this.themeColorDistribution)){
            cssVarObj[key] = this.themeColors[value];
        }
        for(let [key, value] of Object.entries(this.themeColors)){
            cssVarObj[key] = value;
        }
        return cssVarObj;
    }
}

interface ThemeList {
    [name: string]: Theme;
}

export const themes:ThemeList = {
    DEFAULT: new Theme(
        themeColorsList.DEFAULT_THEME,
        themeColorDistributionList.DEFAULT_THEME
    ),
    ROJOS: new Theme(
        themeColorsList.DEFAULT_THEME,
        themeColorDistributionList.DEFAULT_THEME
    )
};